import React, { Component } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import ApiService from "../../_services/ApiService";
import Config from './../../_config/config';

const LabelComponent = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      dominantBaseline="central"
      fontSize="14"
    >
      {`${(percent * 100).toFixed(1)}%`}
    </text>
  );
};

class DoughnutChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pendingResources: 0,
      completedResources: 0,
      resourcesCompletedDelay: 0,
      resourcesNotCompletedDelay: 0,
      totalResourceLength: 0,
      data: [],
      colors: [],
      resource: [],
    };
  }

  //Comp Mount
  componentDidMount() {
    this.getDataFromApi();
  }

  getDataFromApi() {
    // getResource List
    var postJsonData = {
      "resourceTypeIds": [6, 30]
    };
  
    ApiService.getTaskResources(postJsonData)
      .then((res) => {
        // SuccessCB
        const resource = res.data;
        let pendingResources = resource.filter(item => !item.completedDate);
        let completedResources = resource.filter(item => item.completedDate);
        const resourcesCompletedDelay = resource.filter((item) => item.deadline < item.completedDate && item.completedDate !== "");
        const resourcesNotCompletedDelay = resource.filter((item) => item.deadline < item.completedDate && item.completedDate === "");
        completedResources = completedResources.length - resourcesCompletedDelay.length;
        pendingResources = pendingResources.length - resourcesNotCompletedDelay.length;
  
        this.setState({
          resource: resource,
          pendingResources: pendingResources,
          completedResources: completedResources,
          resourcesCompletedDelay: resourcesCompletedDelay,
          resourcesNotCompletedDelay: resourcesNotCompletedDelay,
          totalResourceLength: resource.length,
          data: [
            { name: 'Completed', value: completedResources },
            { name: 'Completed but not met timeline', value: resourcesCompletedDelay.length },
            { name: 'Yet to Complete and Deadline Crossed', value: resourcesNotCompletedDelay.length },
            { name: 'Yet to Complete', value: pendingResources },
          ],
        });

        //this.state.colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
        this.state.colors = ['green','blue','red','orange'];
      })
      .catch(error => {
        // ErrorCB
        console.log("Resource list Error: " + Config.CONNECTION_ERROR);
      });
  }
  
  render() {
    
    return (
      <ResponsiveContainer width="100%" height={500}>
        <PieChart>
          <Pie
            data={this.state.data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={180}
            innerRadius={50}
            fill="#8884d8"
            label={LabelComponent}
          >
            {this.state.data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={this.state.colors[index % this.state.colors.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" height={36} iconType="circle" iconSize={18}/>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default DoughnutChart;
